import React from 'react';
import { TTintColor, TTintColorWithQuantity } from '../types';
import { robotint } from '../components/robotint';

type TProps = {
  setIsTintServiceAvailable: (isAvailable: boolean) => void;
  isTintServiceAvailable: boolean;
  setActiveColor: (activeColor: null | TTintColorWithQuantity) => void;
  setSelectedTintColors: (selectedColor: TTintColor | never) => void;
  deleteColorFromSelected: () => void;
  sendGaClickSelectColorButton: () => void;
};
export const useTintColor = ({
  setSelectedTintColors,
  setIsTintServiceAvailable,
  isTintServiceAvailable,
  setActiveColor,
  deleteColorFromSelected,
  sendGaClickSelectColorButton,
}: TProps) => {
  const handleSelectColor = (color: Required<TTintColor>) => {
    setSelectedTintColors(color);
    robotint.closeModal();
  };

  const openChooseColorModal = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (!isTintServiceAvailable) {
      setIsTintServiceAvailable(true);
    }

    sendGaClickSelectColorButton();

    robotint.openModal(event.currentTarget);
  };

  const handleChangeActiveColor = (color: TTintColorWithQuantity) => setActiveColor(color);

  const handleClickTransparentColorButton = () => {
    setActiveColor(null);
  };

  const handleDeleteColor = () => {
    deleteColorFromSelected();
  };

  return {
    handleSelectColor,
    openChooseColorModal,
    handleChangeActiveColor,
    handleClickTransparentColorButton,
    handleDeleteColor,
  };
};
